import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

/**
 * Utility class for handling # id's in links and scrolling.
 */
class ScrollHandler {
    /**
     * Remove the hash, and store so we can control scrolling
     */
    constructor() {
        this.hash = ScrollHandler.getBrowserHash()
        if (this.hash) {
            this.removeHash()
        }
    }

    /**
     * https://stackoverflow.com/questions/1397329/how-to-remove-the-hash-from-window-location-url-with-javascript-without-page-r/5298684#5298684
     */
    removeHash() {
        var scrollV,
            scrollH,
            loc = window.location
        if ('replaceState' in history)
            history.replaceState('', document.title, loc.pathname + loc.search)
        else {
            // Prevent scrolling by storing the page's current scroll offset
            scrollV = document.body.scrollTop
            scrollH = document.body.scrollLeft

            loc.hash = ''

            // Restore the scroll offset, should be flicker free
            document.body.scrollTop = scrollV
            document.body.scrollLeft = scrollH
        }
    }

    get scrollTarget() {
        return this.hash
    }

    static getBrowserHash() {
        return document.location.hash.substring(1)
    }

    /**
     * manually
     * @param {*} hash
     */
    static addHash(hash) {
        var loc = window.location
        if ('replaceState' in history) {
            history.replaceState(
                '',
                document.title,
                loc.pathname + '#' + hash + loc.search
            )
        }
    }

    static scrollToElement(scrollTarget, offset) {
        var scrollElement = document.getElementById(scrollTarget)
        if (scrollElement) {
            const yOffset = offset ? offset : -100
            const y =
                scrollElement.getBoundingClientRect().top +
                window.scrollY +
                yOffset

            /**
             * listen to scroll events, and do something when scroll target is reached
             */
            const onScroll = () => {
                if (
                    window.scrollY >= scrollElement.getBoundingClientRect().top
                ) {
                    window.removeEventListener('scroll', onScroll)
                    ScrollHandler.addHash(scrollTarget)
                }
            }

            window.scrollTo({ top: y, behavior: 'smooth' })

            /**
             * if hash is empty, probably means we manually removed it, so re-add when scrolling finished
             */
            let hash = ScrollHandler.getBrowserHash()
            if (!hash) {
                window.addEventListener('scroll', onScroll)
            }
        }
    }

    /**
     * add scroll behaviour to all current page hash links
     */
    initScrollLinks() {
        var scrollLinks = document.querySelectorAll('a[href^="#"]')
        scrollLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault()
                var href = event.target.href
                if (href) {
                    var target = event.target.href.substring(
                        href.indexOf('#') + 1
                    )
                    ScrollHandler.scrollToElement(target, -200)
                }
            })
        })
    }

    /**
     * On page load, scroll to the target element.
     * Default browser scrolling should have been disabled in constructor (although currently not working in ff)
     */
    scrollToUrl() {
        if (this.hash) {
            ScrollHandler.scrollToElement(this.hash, -100)
        }
    }
}

export default ScrollHandler
